import store from '../../store';
import { WIDGET_REQUIRED_PROPS } from '../constants';
import { setActions } from '../actions';

export const verifyWidgetProps = function (props = {}) {
  const errors = WIDGET_REQUIRED_PROPS.reduce((accumulator, prop) => {
    if (!props[prop]) {
      accumulator.push(`This widget requires the prop, ${prop}`);
    }

    return accumulator;
  }, []);

  if (errors.length) {
    throw new Error(errors.join(', '));
  }
};

/**
 * Sets data used throughout the settlement flow
 *
 * @param {object} props Data to set
 */
export const hydrateWidget = function (props = {}) {
  store.commit('user/setUser', props.user || {});
  store.commit('application/setApplication', props.application || {});
  store.commit('quote/setQuote', props.quote || {});
  store.commit('settlement/setSettlement', props.settlement || {});
  setActions(props.actions || {});
};
